const state = () => ({
	phoneNumber: '',
	otpFlow: 'login',
	pendingSignupPayload: null,
	adminTotpChallengeToken: '',
	availableContexts: [] as Array<{ type: string; id: string; name: string }>,
});

export default state;
